
export class Customer {
  public id!: string;
  public title!: string;
  public imageUrl?: string;
  public isE015?: boolean;
  public emails?: string[];
  public parentCustomer?: Customer;
}
